<toaster-container [toasterconfig]="toasterconfig"></toaster-container>
<div class="app-body lotas">
    <main class="login d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 mx-auto">
                    <form [formGroup]="form">
                        <div class="card-group">
                            <div class="card p-4">
                                <div class="card-body">
                                    <div class="text-center">
                                        <h3>ロータス・リアルタイム実績管理システム</h3>
                                    </div>
                                    <div class="m-2" style="color: red">
                                        パスワード変更用のメールが登録されているメールアドレスに届きます。メールのリンクからパスワード変更ページで新しいパスワードに変更して下さい。
                                    </div>
                                    <!-- ユーザの有無でメッセージを変えない (アカウント列挙の防止, issue #170) -->
                                    <div *ngIf="sent" class="alert alert-info m-2">
                                        登録メールアドレス宛に案内を送りました。<br>
                                        メールアドレスの登録が無い場合は届きません。支部の管理者にお問い合わせ下さい。
                                    </div>
                                    <div class="input-group mb-1" [ngClass]="{'has-danger': formHelper.hasErrorTooltip(form, username,'username')}" tooltip="ユーザー名は3文字以上にして下さい" triggers="" #username="bs-tooltip" placement="right">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-user"></i></span>
                                        </div>
                                        <input type="text" class="form-control" formControlName="username" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'username')}" placeholder="ユーザー名 または メールアドレス">
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <button type="button" class="btn btn-primary btn-block" [disabled]="!form.valid" (click)="reset(form.value)">送信</button>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12">
                                            ログインは<a [routerLink]="['/login']">こちらで</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</div>
